<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip">
        {{ language.note }}
      </div>
      <div class="confirm-content">{{ language.isAdmin }}</div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button class="button-confirm"
                 type="primary"
                 @click="Hide">{{language.confirm }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  inject: ['gridTemplate'],
  props: {
    language: Object,
    show: Boolean,
  },
  methods: {
    Hide () {
      this.gridTemplate.hideHasAdminDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-tip {
  margin-left: 20px;
}
.confirm-content {
  white-space: pre-wrap;
}
</style>
